import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import AgentChat from "./agentChat/AgentChat";
import ChatMigration from "./chatMigration/ChatMigration";
import "./chatSetting.css";
import Enterkey from "./enterKey";

const ChatSetting = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="custom-tab-container">  
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Enter Key Config" leftIcon="pi pi-key mr-2">
          <Enterkey />
        </TabPanel>
        <TabPanel header="Agent Chats" leftIcon="pi pi-users mr-2">
          <AgentChat />
        </TabPanel>
        <TabPanel header="Chat Migration" leftIcon="pi pi-comments mr-2">
          <ChatMigration />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default ChatSetting;
